import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Importaciones de módulos.
import { ActivationDialogModule } from './activation-dialog/activation-dialog.module';
import { EmployeeCreateDialogModule } from './employee-create-dialog/employee-create-dialog.module';
import { EmployeeDeleteDialogModule } from './employee-delete-dialog/employee-delete-dialog.module';
import { EmployeeUpdateDialogModule } from './employee-update-dialog/employee-update-dialog.module';
import { EmployeeUpdatePasswordDialogModule } from './employee-update-password-dialog/employee-update-password-dialog.module';
import { HostCreateDialogModule } from './host-create-dialog/host-create-dialog.module';
import { HostDeleteDialogModule } from './host-delete-dialog/host-delete-dialog.module';
import { HostUpdateDialogModule } from './host-update-dialog/host-update-dialog.module';
import { LicenseCreateDialogModule } from './license-create-dialog/license-create-dialog.module';
import { LicenseDeleteDialogModule } from './license-delete-dialog/license-delete-dialog.module';
import { LicenseUpdateDialogModule } from './license-update-dialog/license-update-dialog.module';
import { LogDeleteAllDialogModule } from './log-delete-all-dialog/log-delete-all-dialog.module';
import { FooterModule } from './footer/footer.module';
import { HeaderModule } from './header/header.module';
import { ProductCreateDialogModule } from './product-create-dialog/product-create-dialog.module';
import { ProductDeleteDialogModule } from './product-delete-dialog/product-delete-dialog.module';
import { ProductUpdateDialogModule } from './product-update-dialog/product-update-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FooterModule,
    HeaderModule,
    ActivationDialogModule,
    EmployeeCreateDialogModule,
    EmployeeUpdateDialogModule,
    EmployeeUpdatePasswordDialogModule,
    EmployeeDeleteDialogModule,
    ProductCreateDialogModule,
    ProductUpdateDialogModule,
    ProductDeleteDialogModule,
    LicenseCreateDialogModule,
    LicenseUpdateDialogModule,
    LicenseDeleteDialogModule,
    HostCreateDialogModule,
    HostUpdateDialogModule,
    HostDeleteDialogModule,
    LogDeleteAllDialogModule,
  ],
})
export class ComponentsModule {}
